import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=b616580e&scoped=true&"
import script from "./uploadFile.vue?vue&type=script&lang=js&"
export * from "./uploadFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=b616580e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b616580e",
  null
  
)

component.options.__file = "uploadFile.vue"
export default component.exports